<app-header (toggleMenu)="sidenav.toggle()"></app-header>

<mat-sidenav-container>
  <mat-sidenav #sidenav mode="over">
    <mat-nav-list>
      @for (item of menuItems(); track item.route) {
        <a
          mat-list-item
          [routerLink]="item.route"
          (click)="sidenav.close()"
          routerLinkActive
          #rla="routerLinkActive"
          [activated]="rla.isActive">
          {{ item.label }}
        </a>
      }
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-loading/>
    <div class="kyloe-logo-mask"></div>
    <div class="body-component">
      <div class="main-component">
        <router-outlet></router-outlet>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
